import script from "./QuestionPreviewComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./QuestionPreviewComponent.vue?vue&type=script&setup=true&lang=ts"

import "./QuestionPreviewComponent.vue?vue&type=style&index=0&id=3dd808e1&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3dd808e1"]])

export default __exports__